import { Input, InputProps } from "./Input";

export interface TextAreaProps extends Omit<InputProps, "renderContainer"> {

}
export const TextArea = ({ name, label, ...rest }: TextAreaProps) => {
    return <Input renderContainer={(props) => <textarea {...props}></textarea>}
     name={name} label={label} {...rest} className="h-auto p-[12px]" />
}